import { Card, View } from "@/components/ui";
import { useAuth } from "@/components/shared/auth-provider";
import { IntervalScrollVertical } from "@/components/shared/interval-scroll-vertical";
import { words, ROTATE_INTERVAL_MS, SCROLL_DURATION_MS } from "./lib";
import { AuthRemSlideContent } from "./auth-rem-slide-content";
import { AuthRemActionButtons } from "./auth-rem-action-buttons";

export const AuthReminder: React.FC<{ width: number }> = ({ width }) => {
  const { isAuthenticated } = useAuth();
  if (isAuthenticated) return null;
  return (
    <View className="native:absolute fixed bottom-6 px-4">
      <Card
        className="flex flex-row items-center gap-2 p-3"
        shadow={"md"}
        border={"default"}
        style={{ width: width - 32 }}
      >
        <IntervalScrollVertical
          items={words}
          renderItem={(item) => <AuthRemSlideContent slide={item} />}
          intervalMs={ROTATE_INTERVAL_MS}
          scrollDurationMs={SCROLL_DURATION_MS}
          enabled={!isAuthenticated}
        />
        <AuthRemActionButtons />
      </Card>
    </View>
  );
};
